import styled from 'styled-components'

export const Container = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['12'],
  width: '47rem',
}))
